import { useEffect, useState } from "react";

interface Props {
  /** Trigger the animation once when this becomes true. */
  active: boolean;
}

/**
 * Golden circle draw shown once when a reading is completed. Positioned
 * fixed-center, pointer-events none, self-removes after ~3s.
 */
export function CompletionRing({ active }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2800);
    return () => clearTimeout(t);
  }, [active]);

  if (!visible) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-40 grid place-items-center" aria-hidden>
      <svg width="320" height="320" viewBox="0 0 100 100" className="ka-completion">
        <defs>
          <linearGradient id="ka-complete-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="var(--gold-luminous)" />
            <stop offset="100%" stopColor="var(--gold)" />
          </linearGradient>
        </defs>
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="url(#ka-complete-g)"
          strokeWidth="0.8"
          strokeLinecap="round"
          transform="rotate(-90 50 50)"
        />
      </svg>
    </div>
  );
}
